import $ from 'jquery';

$(document).ready(function () {
  acfCardTextBlock();
});

function acfCardTextBlock() {
  $('.js-acf-card-text').each(function () {});
}
